@if(introspectError$) {
<ng-container *ngTemplateOutlet="viewError"></ng-container>
} @else {
<ng-container *ngTemplateOutlet="viewResponse"></ng-container>
}

<ng-template #viewResponse>
  <mat-grid-list cols="12" rowHeight="520px">
    <mat-grid-tile colspan="3"></mat-grid-tile>
    <mat-grid-tile colspan="6">
      <mat-form-field [style.width]="'100%'">
        <mat-label>Introspect Response</mat-label>
        <textarea matInput readonly cols="100" rows="19" [style.resize]="'none'">{{ introspectResponse$ }}</textarea>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile colspan="3"></mat-grid-tile>
  </mat-grid-list>
</ng-template>

<ng-template #viewError>
  <mat-grid-list cols="12" rowHeight="520px">
    <mat-grid-tile colspan="3"></mat-grid-tile>
    <mat-grid-tile colspan="6">
      <mat-form-field [style.width]="'100%'">
        <mat-label>Introspect Error Response</mat-label>
        <textarea matInput readonly cols="100" rows="11" [style.resize]="'none'">{{ introspectResponse$ }}</textarea>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile colspan="3"></mat-grid-tile>
  </mat-grid-list>
</ng-template>